import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const before = ['A project idea', 'A visual reference', 'Clear instructions', 'A technique demo', 'An assessment tool', 'An early-finisher option', 'Then you still have to adapt everything to your students, organize the materials, and make all the pieces work together.'];
const after = ['Plan lessons faster — start with a structured resource instead of opening another round of searches.', 'Keep visual references ready — use clear examples and classroom visuals while students work, not just during your explanation.', 'Teach from a connected sequence — move from observation to experimentation, creation and reflection without rebuilding the flow yourself.', "Find the right project faster — choose adaptable projects and creative challenges already connected to the skill you're teaching.", 'Assess with clearer criteria — use rubrics, checkpoints and reflection tools instead of writing grading criteria after the work is finished.', "Handle different classroom needs — use extensions, simplified pathways and quick activities when the class doesn't move at the same pace.", 'Keep everything in one system — planning, teaching resources, projects, assessment and classroom visuals work together instead of living in separate folders.'];
export function PainSection() {
  return <section className="w-full bg-navy px-5 py-10 sm:py-16" data-id="element-135" data-mp="38wj3nmyp0aoz">
      <div className="mx-auto max-w-5xl" data-id="element-136" data-mp="38x2ll3ocez30">
        <div className="mx-auto max-w-2xl text-center" data-id="element-137" data-mp="33xgc95bmy2zh">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-138" data-mp="33z16etu1fjwt">
            Planning one Art lesson shouldn&apos;t start with an hour of searching.
          </h2>
          <p className="mt-3 text-sm italic text-gold sm:text-base" data-id="element-139" data-mp="3du1fpm80b617">
            The problem isn&apos;t a lack of Art resources. It&apos;s that they&apos;re scattered.
          </p>
        </div>
        <div className="mt-7 grid gap-4 sm:mt-9 sm:gap-6 md:grid-cols-2" data-id="element-140" data-mp="2l65lqp9tns84">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-red-400 bg-maroon p-6 sm:p-8" data-id="element-141" data-mp="p4lqf3ood2y2">
            <h3 className="mb-5 text-lg font-bold text-white sm:text-xl" data-id="element-142" data-mp="64y1ejr1muv0">
              For a single class, you may end up pulling together
            </h3>
            <PainList items={before} icon="x" data-id="element-143" data-mp="b4korm0l5rhj" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-gold bg-navy-mid p-6 sm:p-8" data-id="element-144" data-mp="f5cyegdddyec">
            <h3 className="mb-5 text-lg font-bold text-gold sm:text-xl" data-id="element-145" data-mp="25ochavaorozd">
              What this actually changes in your week
            </h3>
            <PainList items={after} icon="check" data-id="element-146" data-mp="20pi18143seiy" />
          </motion.div>
        </div>
      </div>
    </section>;
}
function PainList({
  items,
  icon
}: {
  items: string[];
  icon: 'x' | 'check';
}) {
  const Icon = icon === 'x' ? XIcon : CheckIcon;
  return <ul className="space-y-3" data-id="element-147" data-mp="1mxuu168mhlle">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-148" data-mp="1mymm4730h16x">
          <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${icon === 'x' ? 'bg-red-500/20 text-red-300' : 'bg-gold/15 text-gold'}`} data-id="element-149" data-mp="1hx730kke94r6">
            <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-150" data-mp="18xtsrpog4c5e" />
          </span>
          <span className="text-sm leading-relaxed text-white/85" data-id="element-151" data-mp="18zwsx2jbblnu">{item}</span>
        </li>)}
    </ul>;
}